import { useEffect, useState } from "react";
import { fmt } from "../domain/units";

export interface NumberInputProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  precision?: number;
  disabled?: boolean;
  id?: string;
}

export const NumberInput = ({
  value, onChange, min, max, step, unit, precision = 2, disabled, id,
}: NumberInputProps) => {
  const [text, setText] = useState(() => fmt(value, precision));

  useEffect(() => {
    setText(fmt(value, precision));
  }, [value, precision]);

  const commit = (raw: string) => {
    const parsed = parseFloat(raw);
    if (!Number.isFinite(parsed)) return;
    let v = parsed;
    if (min !== undefined) v = Math.max(min, v);
    if (max !== undefined) v = Math.min(max, v);
    onChange(v);
  };

  return (
    <div className="numwrap">
      <input
        id={id}
        type="number"
        className="ctl num"
        value={text}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onChange={(e) => {
          setText(e.target.value);
          commit(e.target.value);
        }}
      />
      {unit && <span className="unit">{unit}</span>}
    </div>
  );
};
